const vn = {
    num: 'số seri',
    creator: "Người tạo đơn",
    createdAt: "Thời gian tạo đơn",
    invStatus: 'Tình trạng hàng tồn kho',
    opt: 'vận hành',
    startInv: 'Tôi muốn lấy hàng',
    validaFail: 'Xác minh không hoàn thành',
    invalidFormat: 'Tên sản phẩm và định dạng số lượng phải chính xác',
    operator: 'Nhà điều hành',
    operaTime: 'Thời gian hoạt động',
    invRequest: 'Mẫu đơn xin kiểm kê hàng hóa',
    basicInfo: 'Thông tin cơ bản',
    warehouseItems: 'Hàng kho',
    itemList: 'Danh sách sản phẩm',
    item: 'hàng hóa',
    quantity: 'Số lượng',
    enterQuantity: 'Vui lòng điền số lượng nhập kho',
    cancel: 'Hủy bỏ',
    next: 'Bước tiếp theo',
    addFailed: 'thêm thất bại',
    diffTip: 'So sánh mã vạch kho và mã vạch kiểm kê, có sự khác biệt sau:',
    oneClickInOut: 'One-touch Out/Vào kho',
    oneClickIn: 'Một nút vào thư viện',
    oneClickOut: 'Thư viện One-Click',
    doError: 'Tạo sự khác biệt thất bại，{{err}}',
    operationTips: 'Tổ chức hiện hành đang kiểm kê, không thể tiến hành thao tác.',
    createDiff: 'Tạo sự khác biệt',
    endCounting: 'Kết thúc kiểm kê',
    getDiffDataTip: 'Nhận dữ liệu khác biệt sau...',
    countingDataInventorySuccs: 'Thu thập dữ liệu vào kho thành công',
    countingFinish: 'Kiểm kê xong.',
    countingNoData: 'Dữ liệu không tồn tại',
    countingCancelDiff: 'Dữ liệu chênh lệch hiện tại đã được tạo và sự chênh lệch sẽ kết thúc sau khi hủy.',
    dataMatchFinish: 'Dữ liệu khớp xong, không có dữ liệu khác biệt!',
    diffDataTip: 'Mã vạch tồn tại, kho hàng không tồn tại：',
    diffDataTip2: 'Kho hàng tồn tại, mã vạch không tồn tại trong danh sách kiểm kê：',
    onClickDelete: 'Xóa một cú nhấp chuột',
    seletedItems: 'Chọn giữan {{num}}',
    againAddScan: 'Thêm danh sách quét một lần nữa',
    againDiff: 'Tạo sự khác biệt một lần nữa',
    countingDataIsOverTip: 'Số liệu khác biệt về đơn kiểm kê này đã được tạo ra, xác định giữ lại sự khác biệt và kết thúc lần kiểm kê này sao?',
    countingInSucc: 'Nhập kho thành công',
    countingOutSucc: 'Kiểm kê kho thành công',
    delCountingScanBarcode: 'Bạn có chắc chắn xóa mã vạch trong danh sách kiểm tra này không??',
    barcode: 'Mã vạch',
    countingBarcodeInProduct: 'Trong danh sách các sản phẩm thuộc mã vạch này',
    storeBarcodeInProduct: 'Hàng hóa có mã vạch trong kho',
    optDetail: 'Chi tiết',
    countingDetail: 'Kiểm kê chi tiết',
    countingProductData: 'Kiểm kê dữ liệu hàng hóa',
    overCouting: 'Kết thúc kiểm kê',
    overCoutingTip: 'Có chắc là kết thúc không?',
    fillDataDoTip: 'Vui lòng chọn sản phẩm và điền dữ liệu mã vạch trước khi tạo ra sự khác biệt',
    noDataOverCounting: 'Hiện tại chưa có dữ liệu để kết thúc.',
    diffCodes: "Mã vạch chênh lệch",
    normalCodes: "Mã vạch khớp",
    countingCodes: "Kiểm kê kho",
    confirmDelete: "Xác nhận xóa",
    confirmDeleteContent: "Dữ liệu kiểm kê không thể khôi phục sau khi xóa. Bạn có chắc chắn muốn xóa?",
    deleteSuccess: "Xóa thành công",
    deleteFailed: "Xóa thất bại",
    saveFailed: "Lưu thất bại",
    confirmTerminate: "Xác nhận dừng kiểm kê",
    confirmTerminateContent: "Dừng kiểm kê sẽ xóa phiếu kiểm kê hiện tại. Bạn có chắc chắn muốn dừng không?",
    terminateSuccess: "Phiếu kiểm kê đã bị xóa",
    terminateFailed: "Dừng kiểm kê thất bại",
    addSuccess: "Phiếu kiểm kê đã được tạo",
    itemsUpdated: "Phiếu kiểm kê đã được cập nhật",
    noCode: "Mã hàng lưu kho không tồn tại：{{code}}",
    temp: "Lưu tạm",
    tempSave: "Xác nhận lưu tạm phiếu kiểm kê này?",
    tempSaveConfirm: "Sau khi lưu tạm, bạn sẽ lưu dữ liệu hiện tại.",
    batchImport: "Nhập hàng loạt kiểm kê",
    downloadTemplate: "Tải xuống mẫu",
    importData: "Nhập kiểm kê",
    invalidTemplate: "Vui lòng chọn tệp mẫu đúng",
    confirmImport: "Xác nhận nhập",
    productCode: "Mã hàng",
    productName: "Tên hàng",
    productModal: "Quy cách",
    productUom: "Đơn vị",
    bookNum: "Số lượng sổ sách",
    countedNum: "Số lượng kiểm kê",
    locationIdx: "Vị trí",
    parseDataSuccess: "Đã phân tích thành công {{count}} bản ghi",
    parseDataFilter: "Đã phân tích thành công {{count}} bản ghi, vui lòng kiểm tra dữ liệu bất thường đã lọc (hàng: {{rows}})",
    locationParseFailed: "Không thể phân tích các vị trí: {{locations}}",
    importSuccess: "Nhập kiểm kê thành công",
    countingCompleted: "Hoàn thành kiểm kê",
    confirmCloseImport: "Xác nhận đóng nhập",
    confirmCloseImportContent: "Sau khi đóng, dữ liệu đã nhập sẽ bị mất. Bạn có chắc chắn muốn đóng?",
    confirmDeleteRow: "Xác nhận xóa",
    confirmDeleteRowContent: "Bạn có chắc chắn muốn xóa dữ liệu này không?",
    productCodeNotExisted: "Các mã hàng sau không tồn tại: \"{{codes}}\"",
    countingHistory: "Lịch sử kiểm kê",
    countingHistoryAll: "Lịch sử kiểm kê_Tất cả",
    inventoryImportTemplate: "Mẫu nhập kiểm kê",
    inputTemp: "Nhập từ mẫu",
    noLot: "Không tạo lô (đơn xuất/nhập được tạo sau khi kiểm kê sẽ không tạo lô)",
    initLoc: "Đang chuẩn bị dữ liệu vị trí kho",
    subErr: "Vui lòng nhập lot, mã hàng tồn kho và số lượng",
    countErr: "Kiểm kê thất bại",
    countErrTip: "Các dòng được đánh dấu đỏ kiểm kê không thành công",
    countErrTip1: "Nếu có số đơn thì phiếu kiểm kê đã được tạo nhưng kiểm kê thất bại; nếu không thì phiếu kiểm kê chưa được tạo",
    countNo: "Số phiếu kiểm kê",
    countErrTip2: "Các dòng dữ liệu sau trong tệp Excel có dữ liệu bất thường",
    countErrTip3: "Vui lòng kiểm tra các dòng sau trong tệp Excel: mã hàng tồn kho, số lượng kiểm kê ban đầu, vị trí kho đã được nhập đúng chưa",
    countErrTip4: "Các mã vật liệu sau không tồn tại",
    countErrTip5: "Phân tích thất bại",
    countErrTip6: "Phân tích dữ liệu thất bại. Vui lòng kiểm tra dữ liệu bảng và thử lại sau",
    countErrTip7: "Dòng {{index}}",
};

export default vn;